<script setup lang="ts">
import type { IStep as IProps } from './Step.types'

defineProps<IProps>()
</script>

<template>
  <div
    :class="[
      'step',
      { 'step--empty': !active && !done },
    ]"
  >
    <p :class="['step__text', { 'step__text--active': active }]">
      {{ title }}
    </p>

    <div
      :class="[
        'step__number',
        { 'step__number--active': active, 'step__number--done': done },
      ]"
    >
      {{ index }}

      <img
        v-if="done"
        class="step__check"
        src="/icons/step/check.svg"
      >
    </div>
  </div>
</template>

<style lang="scss" scoped>
.step {
  display: inline-flex;
  justify-content: center;
  align-items: center;

  &__text {
    @include body-3-medium;

    margin-right: 0.8rem;
    color: $text-400;
    text-wrap: nowrap;

    &--active {
      opacity: 1;
    }
  }

  &__number {
    @include body-2-medium;

    position: relative;
    z-index: 5;
    display: flex;
    flex: 0 0 3rem;
    justify-content: center;
    align-items: center;
    width: 3rem;
    height: 3rem;
    color: $text-400;
    background-color: $gray-400;
    border-radius: 50%;

    &--active {
      color: $white;
      background-color: $purple-400;
    }

    &--done {
      color: $white;
      background-color: $text-400;
    }
  }

  &__check {
    position: absolute;
    right: -3px;
    bottom: -5px;
    z-index: 10;
    width: 1.6rem;
    height: 1.6rem;
  }

  &--empty {
    .step__text {
      opacity: 0.7;
    }
  }
}
</style>
